import React from 'react';

function CardBody({ children, className }) {
  return <div className={`card-block ${className || ''} `}>{children}</div>;
}

export default CardBody;



// WEBPACK FOOTER //
// ./src/views/ESG/CustomCard/CardBody.jsx